export default "__VITE_ASSET__B7DUK1Wu__"